<template>
    <div class="barra-lateral-esquerdo">
        <figure @click='deslogar' class="figure-image">
            <div v-if="getDeslog" class="backGroundOrangeRed">
                <img src="/imgs/icons/power-white.svg" class="img">
                <figcaption>Deslogado</figcaption>
            </div>
            <div v-else class="backgroundGreen">
                <img src="/imgs/icons/power-white.svg" class="img">
                <figcaption>Logado</figcaption>
            </div>
        </figure>

		<figure @click="operatorRealtime()" class="figure-image">
      		<div :class="{ 'bg-adv': getOperatorRealtime }">
      		  	<img src="/imgs/icons/realtime-icon.svg" class="img" />
      		  	<figcaption>Realtime</figcaption>
      		</div>
		</figure>

        <figure @click='messages' class='figure-image messagesChange'>
            <div :class="{'bg-adv': getMessages}">
                <div class="remove-padding">
                    <img src="/imgs/icons/chat-square-text-white.svg" class='img' alt="msg">
					<div class="remove-padding" v-if="(getTotalInQueue > 0 && !getMessages)">
						<span class="num">{{ getTotalInQueue }}</span>
					</div>
                </div>
                <figcaption>Atendimento Online</figcaption>
            </div>
        </figure>

		<figure @click="contacts()" class='figure-image'>
			<div :class="{'bg-adv': getContacts}">
				<img src="/imgs/icons/address-book.svg" class='img'>
				<figcaption>Contatos</figcaption>
			</div>
    	</figure>

		<figure  @click="historicol()" class='figure-image'>
			<div :class="{'bg-adv': getShowHistory}">
				<img src="/imgs/icons/arrow-counterclockwise-white.svg" class='img'>
				<figcaption>Histórico</figcaption>
			</div>
		</figure>

		<figure v-if="telefone" class='figure-image'>
            <div v-if="getChannel() != ''" @click="hangup" class="backGroundOrangeRed">
                <img src="/imgs/icons/telephone-forward-white.svg" class='img' alt="">
                <figcaption>Desligar</figcaption>
            </div>
            <div v-else @click="discar">
                <img src="/imgs/icons/telephone-forward-white.svg" class='img' alt="">
                <figcaption>Discar</figcaption>
            </div>
        </figure>

		<figure v-if="telefone" @click="pause" class="figure-image">
			<div v-if='getPause' class="backGroundOrange">
				<img src="/imgs/icons/pause-white.svg" class='img'>
				<figcaption>{{ time_pause_format }} <br> Pausado</figcaption>
			</div>
			<div v-else>
				<img src="/imgs/icons/pause-white.svg" class='img'>
				<figcaption>Pausar</figcaption>
			</div>
		</figure>

		<figure v-if="telefone" @click="mute" class='figure-image'>
			<div v-if='getMute' class="backGroundOrange">
				<img src='/imgs/icons/mute-white.svg' class='img' alt="">
				<figcaption>Mudo</figcaption>
			</div>
			<div v-else>
				<img src='/imgs/icons/mute-white.svg' class='img' alt="">
				<figcaption>Mute</figcaption>
			</div>
		</figure>

        <figure @click='agendamento' class='figure-image' style="display:none">
            <div class="">
                <img src="/imgs/icons/calendar-date-white.svg" class='img'>
                <figcaption>Agendamento</figcaption>
            </div>
        </figure>
       	<div hidden>{{hue}}</div>
    </div>

</template>

<script>
    import { mapGetters, mapActions, mapMutations } from 'vuex';
	import clientData from '../../store/modules/newConnectLine';
	const parsedTelefone = (process.env.MIX_TELEFONE === 'true');

	const isSSL = (location.hostname == 'localhost')? 'http': 'https';
	const connection = (parsedTelefone) ? io.connect(`${isSSL}://${location.hostname}:3002/`) : { 'on': function() {}, 'emit': function() {} };	
    
	export default {
    data() {
        return {
            interval_pause: '',
            time_pause: '',
            time_pause_format: '00:00:00',
            debugDisc: false,
            total_in_queue: '',
            queuesEsquerdo: false,
			setPauseManually: true,
	        queuePause: false,
			telefone: parsedTelefone,
			break: '',
			selectedOption: "",
			contactDono: "",
			observacao: "",
			isBlinking: false,
			redFlag: false,

			hangupObj: {
				dados: [],
				uniqueid: "",
				callerIdNum: "",

			},
			ramal: user.getExtension(),
        }
    },
    computed: {
        ...mapGetters([
            'getDeslog',
            'getModalPause',
            'getMessages',
            'getOccurrences',
            'getShowHistory',
            'getCnpj',
            'getPause',
            'getMute',
            'getQueues',
            'getExtension',
            'getId',
            'getChannel',
            'getChamada',
            'allClients',
            'getShowSpearhead',
            'getProtocol',
            'getCallTime',
            'getPauseTime',
            'oneClient',
            'getShowBarRight',
            'getTotalMyQueue',
            'getTotalInQueue',
			'getContacts',
			'getCalendar',
			'getMotivoPause',
			"getOperatorRealtime",
        ]),

        hue: function() {
            this.setExtension(user.getExtension())
            this.setQueues(user.getQueue())
            this.setId(user.getId())
        },
    },
    watch: {
        getPauseTime: function() {
            this.validateTimePause();
        },
        time_pause: function () {
            this.time_pause_format = moment.utc(this.time_pause * 1000).format('HH:mm:ss')
        },
		getDeslog(value) {
			if (!value) {
				if (!this.getMessages) {
					this.setMessage();
				}
			} 
			else {
				if (this.getMessages) {
					this.setMessage();
				}
			}

			//REGISTRA LOGIN/LOGOUT DA TELA DO OPERADOR (RELATÓRIO DE DURAÇÃO DE LOGIN)
			this.salvarEstadoLogin(!value);
			this.submitLogin(value ? 'LOGOUT' : 'LOGIN');
		},
    },
	created() {
		if(this.telefone) return;

		this.startOrOut();
	},
    methods: {
		...mapActions([
			'selectPause',
			'sendOperatorPauseApi',
			'setOccurrences',
			'setShowHistory',
			'setModalPause',
			'setModalSchedule',
			'settModalCall',
			'setMessage',
			'fetchOcurrences',
			'fetchPauses',
			'comeBack',
			'setDeslog',
			'startOrOut',
			'setMute',
			'setExtension',
			'setQueues',
			'setId',
			'getRealTime',
			'sendOperatorUnpause',
			'setChannel',
			'fetchClients',
			'fetchProtocol',
			'setShowSpearhead',
			'chooseClient',
			'chooseClientCnpj',
			'clearAllClients',
			'setCallTime',
			'setPauseTime',
			'saveProduct',
			'clearClient',
			'saveClient',
			'setShowBarRight',
			'checkTotalQUeues',
			'totalMyQueue',
			'setContacts',
			'chooseClientPhone',
			'joinQueue',
			'leaveQueue',
			'setOperatorRealtime'
		]),
		...mapMutations([
				'setClient',
				'delDataConnectLine',
				'setMotivoPause'
		]),
		validateTimePause() {
			this.time_pause = (this.getPauseTime != 'null') ? this.getPauseTime : 0;
			if(this.getPauseTime != 'null') {
				this.interval_pause = setInterval(() => {
					this.time_pause++;
				}, 1000);
			} 
			else {
				clearInterval(this.interval_pause);
			}
		},
		historicol(event) {
			if(!this.getDeslog && !this.getShowHistory) {
				this.setShowHistory();
				this.fetchOcurrences(this.getCnpj);
			}
		},
		messages() {
			if(!this.getDeslog && !this.getMessages) this.setMessage();
		},
		discar(event) {
			this.settModalCall();
		},
		getTime() {
			var d = new Date();
			return d.toTimeString().replace(/.*(\d{2}:\d{2}:\d{2}).*/, "$1");
		},
		pause() {
			this.queuePause = false;

			if (this.getPause === true) {
				const time = this.getTime();
				const payload = {
					pauseId: 1,
					tempo: `${time}`,
					userId: this.getId,
				};

				connection.emit('QueueUnPause', {
					extension: user.getExtension()
				});

				this.comeBack(`${time}`);
				this.setPauseTime('null');

				this.sendOperatorUnpause(payload);

				return;
			}

			if (this.getDeslog == false) {
				this.setModalPause();
				this.fetchPauses();
			}
		},
		agendamento() {
			this.setModalSchedule();
		},
		async deslogar(){
			//ESTADO ANTES DO CLIQUE: TRUE = ESTÁ ENTRANDO, FALSE = ESTÁ SAINDO
			const entrando = this.getDeslog;

			if(entrando) {
				this.joinQueue(user.getId());
				if(!this.getMessages) this.setMessage();
			} 
			else {
				this.leaveQueue(user.getId());
				this.delDataConnectLine();
				this.chooseClientPhone('');
				if(this.getMessages) this.setMessage();
				if(this.getContacts) this.setContacts();
				if(this.getShowHistory) this.setShowHistory();
			}
			this.setDeslog();
			if(!this.telefone) return;
			var data = {
				queues: [user.getQueue()],
				extension: user.getExtension(),
			}

			connection.emit(entrando ? 'QueueAdd' : 'QueueRemove', data);
		},
		mute() {
			if(this.getChannel()) {
				this.setMute();

				(this.getMute == true)? localStorage.setItem("mute", "true") : localStorage.removeItem("mute") ;

				var stateMute = (this.getMute == true)? 'on' : 'off' ;
				connection.emit('MuteAudio', {
					channel: this.getChannel(),
					extension: user.getExtension(),
					state: stateMute
				});
			}
		},
		async hangup() {
			connection.emit('hangup', {
				channel: this.getChannel()
			})

			await this.setChannel('');

			await clientData.mutations.delDataConnectLine();
		},
		submitLogin(sub) {
			axios.post('/dialer/logs', { type: sub, extension_line: user.getExtension() }).then((response) => {
					console.info(response);
			}, function(response) {
					console.error(response);
			});
		},
		contacts() {
			if(!this.getDeslog && !this.getContacts) this.setContacts();
        },
		salvarEstadoLogin(estaLogado) {
			sessionStorage.setItem('operador_logado', estaLogado ? 'true' : 'false');
		},
		cancelarLogoutDoF5() {
			return axios.post('/dialer/cancel-page-logout', {
				extension_line: user.getExtension()
			}).catch(() => {});
		},
		//F5: REMOVE O LOGOUT_PAGE GERADO AO RECARREGAR. ABA NOVA APÓS FECHAR: ENCERRA A SESSÃO
		async restaurarEstadoLogin() {
			if (sessionStorage.getItem('operador_logado') === 'true') {
				await this.cancelarLogoutDoF5();
				return true;
			}

			try {
				const response = await axios.get('/dialer/last-log');
				if (response.data.system_logout === true) {
					window.location.replace('/');
					return false;
				}
			} catch (error) {
				console.error(error);
			}
			return true;
		},
		//AO SAIR DA TELA DO OPERADOR (FECHAR ABA, F5 OU NAVEGAR) REGISTRA LOGOUT_PAGE
		closeTabLogout() {
			if (sessionStorage.getItem('operador_logado') !== 'true') return;

			const form = new FormData();
			form.append('type', 'LOGOUT_PAGE');
			form.append('extension_line', user.getExtension());

			const csrfMeta = document.querySelector('meta[name="csrf-token"]');
			if (csrfMeta) form.append('_token', csrfMeta.getAttribute('content'));

			navigator.sendBeacon('/dialer/logs', form);
		},
		operatorRealtime() {
      	if(!this.getOperatorRealtime){
      	  	if(user.getProfile() == 2){
				if(!this.getDeslog) this.setOperatorRealtime();
      	  	} else {
      	  	  	this.setOperatorRealtime();
      	  	}
      	}
    	},
    },
    async mounted() {
		if (!(await this.restaurarEstadoLogin())) return;

		window.addEventListener('pagehide', this.closeTabLogout);
		window.onbeforeunload = () => {
			this.leaveQueue(user.getId());
		};
		this.deslogar()
		if(!this.getMessages) this.setMessage();

		this.checkTotalQUeues();
		this.totalMyQueue();

		connection.emit('CoreShowChannels', {
			ramal: user.getExtension()
		});

		connection.on(`CoreShowChannel-${user.getExtension()}`, data => {			
			this.setCallTime(moment.duration(data.Duration).asSeconds());

			var self = this;

			this.fetchClients(data.ConnectedLineNum).then(async function() {
				let phoneSplit = data.ConnectedLineName.split('||');
				let dataPhone = phoneSplit[1];

				if(self.allClients && self.allClients.length > 0) {
					self.chooseClient(self.allClients[0]);
					self.chooseClientCnpj(self.allClients[0]["cpf_cnpj"]);
					self.setShowSpearhead();
					// self.clearAllClients();
				} else {
					self.chooseClient({
						at_user_id: '',
						birthday: '',
						cep: '',
						city: '',
						complement: '',
						cpf: '',
						created_at: '',
						email: '',
						id: '',
						name: '',
						neighborhood: '',
						number: '',
						phone: dataPhone,
						phone_2: '',
						reference: '',
						rg: '',
						street: '',
						updated_at: ''
					});
					self.setShowSpearhead();
				}
			});
			this.fetchProtocol();

			this.setChannel(data.Channel);

			(localStorage.getItem("mute") && this.getChannel() && this.getMute == false)? this.setMute() : false ;
		});

		connection.emit('QueueStatus', {
			ramal: user.getExtension()
		});

		var validate = 0;
		connection.on(`QueueMember-${user.getExtension()}`, data => {
			if(validate == 0) {
				if(data.Paused == 1) {
					this.setPauseTime(data.LastPause);
					this.comeBack();
				}
				
				//JÁ ESTÁ NA FILA: SÓ ALINHA O BOTÃO (NÃO ALTERNA)
				if(this.getDeslog) this.setDeslog();
				validate = 1
				this.queuesEsquerdo = true;
			}
		});

		connection.on(`QueueMemberAdded-${user.getExtension()}`, data => {
			//ENTROU NA FILA: SÓ ALINHA O BOTÃO SE AINDA ESTIVER DESLOGADO (EX.: ADICIONADO PELO REALTIME)
			if(this.getDeslog) {
				this.setDeslog();
				this.startOrOut();
			}
			this.queuesEsquerdo = true;
		});

		connection.on(`QueueMemberRemoved-${user.getExtension()}`, data => {
			if(this.getPause == true && !this.setPauseManually) {
				var time = this.getTime();
				var x = {
						"pauseId":1,
						"tempo":`${time}`,
						"userId":this.getId,
				}
				this.comeBack(`${time}`);
				this.sendOperatorUnpause(x);
			}

			//SAIU DA FILA: SÓ ALINHA O BOTÃO SE AINDA ESTIVER LOGADO (EX.: REMOVIDO PELO REALTIME)
			if(!this.getDeslog) {
				this.setDeslog();
				this.startOrOut();
			}
			this.queuesEsquerdo = false;
		});

		connection.on(`NewConnectedLine-${user.getExtension()}`, async data => {
			this.chooseClientPhone('');

			await clientData.mutations.setDataConnectLine(data.ConnectedLineName);

			let phoneSplit = data.ConnectedLineName.split('||');
			let dataPhone = phoneSplit[1];

			this.setCallTime(1);

			var self = this;
			this.fetchClients(dataPhone).then(function() {
				if(self.allClients && self.allClients.length > 0) {
					self.chooseClient(self.allClients[0]);
					self.chooseClientCnpj(self.allClients[0]["cpf_cnpj"]);
					self.setShowSpearhead();
					self.clearAllClients();
				} 
				else {
					self.chooseClient({
						at_user_id: '',
						birthday: '',
						cep: '',
						city: '',
						complement: '',
						cpf: '',
						created_at: '',
						email: '',
						id: '',
						name: '',
						neighborhood: '',
						number: '',
						phone: dataPhone,
						phone_2: '',
						reference: '',
						rg: '',
						street: '',
						updated_at: ''
					});
					self.setShowSpearhead();
				}
			});
			this.fetchProtocol();

			this.setChannel(data.Channel);
		});

		connection.on(`Hangup-${user.getExtension()}`, async data => {
			console.log("HANGUP:::", data);
			this.hangupObj["uniqueid"] = data.Linkedid;
			if(this.ramal != 4452){
				if (data.ConnectedLineName != "<unknown>") {
					let splitClientNum = data.ConnectedLineName.split("||");
					let clientNum = splitClientNum[1];
					this.hangupObj["dados"] = splitClientNum;
					this.hangupObj["callerIdNum"] = data.CallerIDNum;
					let splitTimeCall = data.ConnectedLineName.split("||");

					let timeCall = moment
						.utc(splitTimeCall[2] * 1000)
						.format("HH:mm:ss");

					console.log("TIME CALL: ",timeCall);

					timeCall = splitTimeCall[2] !== undefined ? timeCall : '0';
				}
			}

			this.delDataConnectLine();
			this.setShowSpearhead();
			if(localStorage.getItem("mute")) {
				this.setMute()
				localStorage.removeItem("mute");
			}

			var structClient = {
				at_user_id: this.getId,
				protocol: this.getProtocol.protocol,
				uniqueid: data.Linkedid,
				type: 'telefonia',
				created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
				updated_at: moment().format("YYYY-MM-DD HH:mm:ss"),
			};

			structClient.cpf_cnpj = this.oneClient ? this.oneClient.cpf_cnpj : null;
			this.saveClient(structClient);
			this.setCallTime('null');
			this.clearClient();
			this.clearAllClients();
			this.setChannel('');

			$('.select2-multi').val('-1').trigger('change');

			await clientData.mutations.delDataConnectLine();
		});

		connection.on(`QueueMemberPause-${user.getExtension()}`, data => {
			if(this.queuePause) return;
			this.queuePause = true;

			if(data.Paused == 1) {
				this.setPauseTime(0);
				var time = this.getTime();
				var x = {
					"pauseId": data.PausedReason,
					"tempo":`${time}`,
					"userId":this.getId,
				}

				this.sendOperatorPauseApi(x);
				this.selectPause(x);
			}

			// Saiu da pausa
			if(data.Paused == 0 && !this.setPauseManually) {
				var time = this.getTime();
				var x = {
					"pauseId": data.PausedReason,
					"tempo":`${time}`,
					"userId":this.getId,
				}
				
				this.comeBack(`${time}`);
				this.sendOperatorUnpause(x);
				this.setPauseTime('null');
			}
		});
    },
	beforeDestroy() {
		window.removeEventListener('pagehide', this.closeTabLogout);
	}
}
</script>


<style scoped>

	.blink-red {
			animation: blink-red 1s infinite;
	}

	@keyframes blink-red {
		0% { background-color: red; }
		50% { background-color: transparent; }
		100% { background-color: red; }
	}
    .num {
        width: 25px;
        height: 25px;
        text-align: center;
        text-combine-upright: all;
        left: 4em;
        border-radius: 50%;
        line-height: 25px;
        color: white;
        background-color: red;
        top: 5.5em;
        position: absolute;
    }

    .barra-lateral-esquerdo {
        background-color: #CCCCCC;
        width: 100%;
        max-width: 99px;
        text-align: center;
        border-right: solid 1px #1C869A;
         min-height: 100%;
        height: calc(100vh - 4.5em);
			overflow: auto;
    }

	::-webkit-scrollbar {
		width: 0.18rem;
	}

	::-webkit-scrollbar-track {
		background: #f38630;
	}

	::-webkit-scrollbar-thumb {
		background: #1c869a;
	}

    .figure-image {
        margin: 0px;
        display: block;
    }

    .figure-image div {
        margin: 0px;
        padding: 9px 0 9px 0;

    }

    .figure-image figcaption {
        color:white
    }

    .backGroundOrangeRed {
        background-color: orangered;
    }

    .backGroundOrange {
        background-color: #fea33b;
    }

    .bg-adv {
        background: #1c869a;
    }

    .backgroundGreen {
        background: #27ae60;
    }

    .count-msg {
        padding: 0px;
        color: white;
        font-size: 1.5em;
    }

    strong .count-msg {
        font-size: 1.5em;
    }

    .remove-padding {
        padding: 0 !important;
    }
</style>



